<template>
  <div id="visita-registra">
    <template>
      <v-btn color="lime darken-2" dark class="mb-3" @click="volver()">
        <!-- window.history.back() $router.go(-1) -->
        <v-icon right dark>arrow_back_ios</v-icon>Volver
      </v-btn>
    </template>
    <v-layout align-center justify-center>
      <v-flex lg10>
        <v-card>
          <v-container>
            <v-toolbar color="white" dark flat dense cad>
              <v-toolbar-title class="indigo--text"
                >Datos de visita</v-toolbar-title
              >
            </v-toolbar>
            <v-form>
              <v-container>
                <v-layout>
                  <v-flex sm6 lg6>
                    <!-- DATOS DE VISITA -->
                    <data-visita
                      :key="actualVisitaData"
                      :idVisita="id"
                      :tipeView="tipeView"
                    ></data-visita>
                    <!-- DATOS DE VISITA -->
                  </v-flex>
                  <v-flex sm6 lg6>
                    <v-toolbar
                      v-if="tipeView != 'crear'"
                      color="white"
                      dark
                      flat
                      dense
                      cad
                    >
                      <v-toolbar-title class="indigo--text"
                        >Historico de estados</v-toolbar-title
                      >
                    </v-toolbar>
                    <!-- INICIO HISTORICO DE ESTADOS -->
                    <grid-estado-visita
                      :key="actualVisitaEstados"
                      v-if="tipeView != 'crear'"
                      :idVisita="id"
                      :fatherLoad="fatherLoad"
                      :tipeView="tipeView"
                    ></grid-estado-visita>
                    <!-- FIN HISTORICO DE ESTADOS -->
                  </v-flex>
                </v-layout>
                <v-layout>
                  <v-flex>
                    <v-toolbar color="white" dark flat dense cad>
                      <v-toolbar-title
                        v-if="tipeView != 'crear'"
                        class="indigo--text"
                        >Visita padre</v-toolbar-title
                      >
                    </v-toolbar>
                    <!-- INICIO DATOS DE VISITA PADRE -->
                    <grid-visita-parent
                      :key="padreParentGrid"
                      v-if="tipeView != 'crear'"
                      :idVisita="id"
                      :tipeView="tipeView"
                      parent="PADRE"
                    ></grid-visita-parent>
                    <!-- TERMINO DATOS DE VISITA PADRE -->
                  </v-flex>
                </v-layout>
                <v-layout>
                  <v-flex>
                    <v-toolbar color="white" dark flat dense cad>
                      <v-toolbar-title
                        v-if="tipeView != 'crear'"
                        class="indigo--text"
                        >Visita hija</v-toolbar-title
                      >
                    </v-toolbar>
                    <!-- INICIO DATOS DE VISITA HIJA -->
                    <grid-visita-parent
                      :key="hijoParentGrid"
                      v-if="tipeView != 'crear'"
                      :visitaId="id"
                      :tipeView="tipeView"
                      parent="HIJA"
                    ></grid-visita-parent>
                    <!-- TERMINO DATOS DE VISITA HIJA -->
                  </v-flex>
                </v-layout>
              </v-container>
            </v-form>
          </v-container>
        </v-card>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import Vue from "vue";
import DataVisita from "@/modules/visitas/views/VisitaData.vue";
import GridVisitaParent from "@/modules/visitas/views/GridVisitaParent.vue";
import GridEstadoVisita from "@/modules/visitas/views/GridEstadoVisita.vue";
import axios from "axios";

export default {
  name: "visita-registra",
  components: {
    DataVisita,
    GridVisitaParent,
    GridEstadoVisita,
  },
  props: {
    proveedor: {},
    show: Boolean,
    tipeView: "",
    tipo: "",
  },
  data() {
    return {
      actualVisitaData: 0,
      actualVisitaEstados: 10,
      padreParentGrid: 20,
      hijoParentGrid: 30,
      parent: "",
      contratoId: "",
      id: "",
    };
  },

  computed: {},

  created() {},
  mounted() {
    this.contratoId = this.$store.getters.contratoStored;
    this.tipeView = this.$route.params.tipeView;
  },
  methods: {
    reloadVisita() {
      (this.actualVisitaData += 1),
        (this.actualVisitaEstados += 20),
        (this.padreParentGrid += 30),
        (this.hijoParentGrid += 40);
    },

    volver() {
      this.$router.back();
    },
  },
};
</script>
